import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getOptimizedSocialImage } from '../../utils/imageUtils';

const BlogPostSchema = ({ blog }) => {
  // Safety check - if blog is not available, don't render schema
  if (!blog || typeof blog !== 'object') {
    console.log('BlogPostSchema: Blog object not available');
    return null;
  }

  // Format date to ISO 8601 format required by schema.org
  const formatDate = (dateString) => {
    if (!dateString) return null;
    return new Date(dateString).toISOString();
  };

  // Create the JSON-LD schema for blog posts
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: blog.title || 'Blog Post',
    description: blog.excerpt || '',
    image: getOptimizedSocialImage(blog.heroImage, 'blog'),
    author: {
      '@type': 'Person',
      name: blog.authorName || 'Jobs Opportunity Team'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Jobs Opportunity',
      logo: {
        '@type': 'ImageObject',
        url: 'https://jobsopportunity.in/images/logo-dark.png'
      }
    },
    datePublished: formatDate(blog.publicationDate),
    dateModified: formatDate(blog.updatedAt || blog.publicationDate),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://jobsopportunity.in/blog/${blog.slug || 'post'}`
    },
    articleSection: blog.category || 'Career Advice',
    keywords: blog.tags?.join(', ') || 'jobs, career, employment, opportunities',
    wordCount: blog.content?.length || 0,
    timeRequired: `PT${Math.ceil((blog.content?.length || 0) / 200)}M`, // Reading time
    inLanguage: 'en-US',
    isAccessibleForFree: true
  };

  // Debug logging
  console.log('BlogPostSchema Debug:', {
    blogExists: !!blog,
    blogType: typeof blog,
    originalImage: blog.heroImage,
    finalImage: getOptimizedSocialImage(blog.heroImage, 'blog'),
    title: blog.title,
    slug: blog.slug
  });

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default BlogPostSchema; 